import { Field, FieldProps, useFormikContext } from 'formik';
import moment from 'moment';
import React, { useCallback } from 'react';
import { Form } from 'react-bootstrap';
import ReactDatePicker from 'react-datepicker';
import { UIDConsumer } from 'react-uid';
import { ErrorI18n, Help } from '..';

export type DatepickerProps = {
  controlId: string;
  label?: string;
  className?: string;
  disabled?: boolean;
  help?: string;
};

export const DATE_FORMAT = 'yyyy/MM/dd';

export const Datepicker = ({ controlId, label, className = '', disabled = false, help }: DatepickerProps) => {
  const { setFieldValue, setFieldTouched } = useFormikContext();

  function handleChange(value: Date | [Date | null, Date | null] | null) {
    setFieldTouched(controlId, true);
    if (value && !Array.isArray(value)) {
      // add 12 hours to avoid the server to compute the date to one day before (because of the timezone)
      setFieldValue(controlId, moment(value).hour() >= 12 ? value : moment(value).add(12, 'hours').toDate());
    } else {
      setFieldValue(controlId, undefined);
    }
  }

  const formatDate = useCallback((value: any) => (value ? (typeof value === 'string' ? moment(value).toDate() : value) : undefined), []);

  return (
    <div className={`datepicker${className ? ` ${className}` : ''}`}>
      <Field name={controlId}>
        {({ field, meta }: FieldProps) => (
          <Form.Group controlId={controlId} className="form-group">
            {label && <Form.Label>{label}</Form.Label>}
            {help && <Help placement="top">{help}</Help>}
            <UIDConsumer>
              {(id) => (
                <ReactDatePicker
                  id={`datepicker_${id}`}
                  dateFormat={DATE_FORMAT}
                  placeholderText={DATE_FORMAT.toLowerCase()}
                  selected={formatDate(field.value)}
                  onChange={(value) => handleChange(value)}
                  onBlur={field.onBlur}
                  autoComplete="off"
                  disabled={disabled}
                  className={`form-control${!meta.error && meta.touched ? ' is-valid' : ''}${
                    !!meta.error && meta.touched ? ' is-invalid' : ''
                  }`}
                />
              )}
            </UIDConsumer>
            <ErrorI18n {...meta} />
          </Form.Group>
        )}
      </Field>
    </div>
  );
};
